import { useMemo } from 'react';
import { useAppSelector } from 'app/store/store';
import { useGetAllValue } from './useGetAllValue';
import { Area, PortCatalogData } from 'ais-facade-api/api';
import { useGetFilterOptionsQuery } from 'app/api/facade';
import { FormEquality } from 'app/helpers/getVesselsFilterFormEquality';

export interface initialValuesRawI {
  touched: boolean;
  formEquality?: FormEquality | null;
  fleetOnly: boolean;
  source: string[] | undefined;
  status: string[] | undefined;
  country: string[] | undefined;
  type: string[] | undefined;
  fleetGroup: string[] | undefined;
  statusAll: boolean;
  typeAll: boolean;
  countryAll: boolean;
  sourceAll: boolean;
  fleetGroupAll: boolean;

  constructionDate_from: string | undefined;
  constructionDate_to: string | undefined;

  eta_from: string | undefined;
  eta_to: string | undefined;

  sog_min: string | undefined;
  sog_max: string | undefined;

  cog_min: string | undefined;
  cog_max: string | undefined;

  draught_min: string | undefined;
  draught_max: string | undefined;

  heading_min: string | undefined;
  heading_max: string | undefined;

  destinationPortKey: Array<string>;
  inPortKey: Array<string>;
  inAreaCode: Array<string>;

  selectedInPort: PortCatalogData | undefined;
  selectedDestinationPort: PortCatalogData | undefined;
  selectedInArea: Area | undefined;
}
export const useGetInitialFilterValues = () => {
  const uiConfig = useAppSelector((state) => state.userSlice.uiConfig);

  const { data } = useGetFilterOptionsQuery();

  const allStatuses = useGetAllValue(data?.filter?.status?.values);
  const allSources = useGetAllValue(data?.filter?.source?.values);
  const allTypes = useGetAllValue(data?.filter?.type?.values);
  const allCountries = useGetAllValue(data?.filter?.country?.values);
  const allFleetGroups = useGetAllValue(data?.filter?.fleetGroup?.values);

  const initialValues: initialValuesRawI = useMemo(() => {
    return {
      touched: false,
      formEquality: null,
      fleetOnly: uiConfig?.viewportFleetOnly || false,
      source: allSources,
      status: allStatuses,
      type: allTypes,
      country: allCountries,
      fleetGroup: allFleetGroups,
      statusAll: true,
      typeAll: true,
      countryAll: true,
      sourceAll: true,
      fleetGroupAll: true,

      inPortKey: [],
      selectedInPort: undefined,

      destinationPortKey: [],
      selectedDestinationPort: undefined,

      inAreaCode: [],
      selectedInArea: undefined,

      constructionDate_from: undefined,
      constructionDate_to: undefined,

      eta_from: undefined,
      eta_to: undefined,

      sog_min: undefined,
      sog_max: undefined,

      cog_min: undefined,
      cog_max: undefined,

      heading_min: undefined,
      heading_max: undefined,

      draught_min: undefined,
      draught_max: undefined,
    };
  }, [allCountries, allSources, allTypes, allStatuses, allFleetGroups, uiConfig]);

  return initialValues;
};
